<template>
  <m-dialog ref="timespentPADlg" :btnsave="false" title="Dashboard Time Spent">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8" v-if="iframeUrl">
        <iframe :src="iframeUrl" frameborder="0" width="800" height="600" allowtransparency></iframe>
      </v-col>
      <v-col cols="12" sm="12" md="10" lg="8" xl="8" v-else>
        Dalam proses mohon ditunggu...
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {
  data() {
    return {
      iframeUrl: null,
    };
  },
  methods: {
    open(url) {
      this.iframeUrl = null;
      this.iframeUrl = encodeURI(url);
      let x = this.$refs.timespentPADlg.open();
      this.$validator.reset();
      return x;
    }
  }
};
</script>
